<template>
  <div class="MyHome">
    
    <div class="main">
      <div class="main_header">
		  <div class="main_headers">
			  <img src="../../../assets/images/juxing.png" alt="" />
			  <span>商户信息</span>
		  </div>
       <rs-button @click='$router.back()' style='margin-right:10px ;'>返回</rs-button>
      </div>
      <div class="main_Main">
        <div class="main_left">
          <div class="main_left1">
            <div style="color: #666">商户名称:</div>
            <div style="">&nbsp;{{tabdate.corporationName}}</div>
          </div>
          <div class="main_left1">
            <div style=" color: #666">商户编号:</div>
            <div style="">&nbsp;{{tabdate.corporationIdNumber}}</div>
          </div>
          <div class="main_left1">
            <div style=" color: #666">商户类型:</div>
            <div style="">&nbsp;{{tabdate.lesseeTypeDesc}}</div>
          </div>
         <!-- <div class="main_left1">
            <div style="color: #666">商户简介:</div>
            <div style="">&nbsp;</div>
          </div> -->
          
          <div class="main_left1">
            <div style=" color: #666">商户详情地址:</div>
            <div style="">&nbsp;{{tabdate.adressListName}}</div>
          </div>
        </div>
        <div class="main_right" >
         <!-- <div class="main_left1" >
            <div style=" color: #666">商户LOGO:</div>
            <div style="">&nbsp;</div>
          </div> -->
         <div v-if="list!==[]" class="main_left1" >
            <div style="color: #666">商户联系人:</div>
            <div style="">&nbsp;{{list.contactName}}</div>
          </div>
		  <div v-else class="main_left1" >
		     <div style="color: #666">商户联系人:</div>
		     <div style="">&nbsp;{{ }}</div>
		   </div>
		   <div v-if="list!==[]" class="main_left1" >
		     <div style=" color: #666">联系电话:</div>
		     <div style="">&nbsp;{{list.contactPhone}}</div>
		   </div>
          <div v-else class="main_left1" >
            <div style=" color: #666">联系电话:</div>
            <div style="">&nbsp;{{ }}</div>
          </div>
		  <div class="main_left1">
		    <div style=" color: #666">经营品牌:</div>
		    <div style="">&nbsp;{{tabdate.operatingBrand}}</div>
		  </div>
        </div>
      </div>
    </div>
    <div class="main" v-if="link">
      <div class="main_header">
		 <div> <img src="../../../assets/images/juxing.png" alt="" />
        <span>企业资质</span></div>
		  
       
      </div>
      <div class="main_Main">
        <div class="main_left">
          <div class="main_left1">
            <div style=" color: #666">营业执照注册号:</div>
            <div style="">&nbsp;{{tabdate.corporationIdNumber}}</div>
          </div>
          <!-- <div class="main_left1">
            <div style=" color: #666">营业执照有效期:</div>
            <div style="">&nbsp;{{tabdate.businessLicenseRegistrationExpiryDate}}</div>
          </div> -->
           <div class="main_left1" >
            <div style=" color: #666;display: flex;" >营业执照照片:
			<div v-if="peice!==[]" v-for="item in peice">
				<img :src="item.attachmentUrl" style="width: 50px;height: 50px;">
			</div>
			<div v-else >
				<img src="" style="width: 50px;height: 50px;">
			</div>
			</div>
            <div style="">&nbsp;</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import API from "@/api/pay";
import Until from '../../../utils/utils'
export default {
  name: "MyHome",
  data() {
    return {
		link:false,
      tabdate:[],
	  list:[],
	  peice:[]
    };
  },
  created(){
    this.getUserList()
  },
  methods:{
    //获取商户信息详情
     getUserList(){
          let lesseeId= Until.getSession("pay").shopVo.shopId;
         let mallCode= Until.getSession("pay").shopVo.mallCode;
        console.log(mallCode )
        //参数lesseeId：商户id，mallCode：项目code
        let params={
          lesseeId:lesseeId,
         mallCode:mallCode
        }
       API.lesseedetail(params).then((res)=>{
         console.log('商户信息详情',res.data.data.concateResVoList)
         this.tabdate=res.data.data
		 this.peice=res.data.data.attachmentList
		 console.log(this.peice)
		 if(res.data.data.attachmentList.length>0){
		 			 console.log(111)
		 this.peice=res.data.data.attachmentList
		 console.log(this.peice.length)
		 }else {
		 			 console.log(22)
		 			 this.peice=[]
		 }
		 if(res.data.data.concateResVoList.length>0){
			 console.log(111)
		 this.list=res.data.data.concateResVoList[0]
		 console.log(this.list.length)
		 }else {
			 console.log(22)
			 this.list=[]
		 }
         console.log(res.data.data.lesseeType=true)
		 if(res.data.data.lesseeTypeDesc=='企业'&&res.data.data.lesseeType==true){
			 this.link=true
		 }
       })
    }
  }
};
</script>
<style lang='scss' scoped>
.MyHome {
  height: 100%;
  background-color: #ebebeb;
}
.rs-row {
  margin-bottom: 20px;
  &:last-child {
    margin-bottom: 0;
  }
}
.bg-purple-dark {
  background-color: #ffffff;
  color: black;
  font-weight: bold;
  font-size: 15px;
  padding-left: 20px;
}
.grid-content {
  /* border-radius: 4px; */
  height: 40px;
  line-height: 40px;
}
.main {
  padding: 10px;
}
.main_header {
  display: flex;
  align-items: center;
  background-color: #ffffff;
  height: 50px;
  border-bottom: 1px solid #ccc;
  justify-content:space-between;
}
.main
.main_header img {
  width: 0.2rem;
  height: 0.8rem;
  margin-left: 10px;
}
.main_header span {
  font-size: 15px;
  font-weight: bold;
  color: black;
  margin-left: 10px;
}
.main_Main {
  background-color: white;
  display: flex;
}
.main_left,
.main_right {
  width: 50%;
  padding: 20px;
}
.main_left1 {
  display: flex;
  line-height: 2.5em;
/*  align-items: center; */
}
</style>